import "./orders.css";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useState, useContext, useEffect, useCallback } from "react";
import { OrderContext } from "../../context/orderContext/OrderContext";
import { getOrders } from "../../context/orderContext/OrderApiCalls";
import FeedbackIcon from "@mui/icons-material/Feedback";
import { styled } from "@mui/system";

const SearchInput = styled("input")({
  padding: "5px",
  marginBottom: "5px",
  fontSize: "16px",
  border: "none",
  borderBottom: "1px solid gray",
});

export default function Orders() {
  const { orders, dispatch } = useContext(OrderContext);
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const columns = [
    {
      field: "dateOfApproval",
      headerName: "Order Date",
      type: "date",
      minWidth: 150,
      flex: 0.3,
    },
    {
      field: "orderNumber",
      headerName: "Order Number",
      minWidth: 170,
      flex: 0.3,
    },
    { field: "reference", headerName: "Reference", minWidth: 250, flex: 1 },
    {
      field: "unloadingDate",
      headerName: "Unloading Date",
      type: "date",
      minWidth: 150,
      flex: 0.3,
    },
    {
      field: "salesPrice",
      headerName: "Price",
      type: "number",
      minWidth: 130,
      flex: 0.3,
    },
    {
      field: "actions",
      headerName: "Claim",
      type: "actions",
      flex: 0.1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<FeedbackIcon />}
          label="Open"
          onClick={newClaim(params.id)}
        />,
      ],
    },
  ];

  const newClaim = useCallback(
    (id) => () => {
      localStorage.removeItem("claimOrder");
      navigate("/orders/" + id + "/newClaim");
    },
    [navigate]
  );

  useEffect(() => {
    getOrders(dispatch);
  }, [dispatch]);

  const search = (data) => {
    return data.filter(
      (item) =>
        item.dateOfApproval.toLowerCase().includes(query) ||
        item.orderNumber.toLowerCase().includes(query) ||
        item.reference.toLowerCase().includes(query) ||
        item.salesPrice.toString().toLowerCase().includes(query) ||
        item.unloadingDate.toLowerCase().includes(query)
    );
  };

  return (
    <div className="orders">
      <h3 className="orderListTitle">Orders</h3>
      <SearchInput
        type="text"
        placeholder="search..."
        onChange={(e) => setQuery(e.target.value.toLowerCase())}
      />
      <DataGrid
        className="ordersList"
        rows={search(orders)}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50, 100]}
        disableSelectionOnClick
      />
    </div>
  );
}
